<template>
  <div class="card" :class="{ active }">
    <div class="card__body">
      <div class="card__body-cover">
        <img class="card__body-cover-image" :src="imageSrc" alt="Product">
        <span class="card__body-cover-checkbox">
          <svg class="card__body-cover-checkbox--svg" viewBox="0 0 12 10">
            <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
          </svg>
        </span>
      </div>
      <header class="card__body-header">
        <slot name="header" />
      </header>
      <div class="card__body-content">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCard',
  props: {
    imageSrc: String,
    active: Boolean
  }
}
</script>

<style scoped lang="scss">
.card {
  --background: #fff;
  --background-checkbox: #38948F;
  --background-image: #fff, #{rgba(#006baf, 0.2)};
  --text-color: #666;
  --text-headline: #000;
  --card-shadow: #38948F;
  --card-radius: 12px;
  --blend-mode: overlay;
  --transition: 0.15s;

  display: inline-block;
  width: 284px;
  min-height: 235px;

  &.active {
    .card__body {
      box-shadow: 0 0 0 3px var(--card-shadow);
      &-cover {
        &:after {
          background: none;
          opacity: 1;
          transition: opacity var(--transition) linear;
        }
      }
    }

    .card__body-cover-checkbox {
      opacity: 1;
      transform: scale(1);
    }

    .card__body-cover-checkbox--svg {
      stroke-dashoffset: 0;
    }

    .card__body-cover-image {
      filter: grayscale(0);
    }
  }

  .card__body {
    background: var(--background);
    width: 100%;
    border-radius: var(--card-radius);
    overflow: hidden;
    position: relative;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);
    transition: transform var(--transition), box-shadow var(--transition);
    transform: scale(1) translateZ(0);

    .card__body-cover-image {
      width: 100%;
      height: 177px;
      object-fit: contain;
    }

    &:active {
      transform: scale(0.99);
    }

    &-cover {
      --c-border: var(--card-radius) var(--card-radius) 0 0;
      --c-width: 100%;
      --c-height: 100%;
      position: relative;
      width: 100%;
      height: auto;

      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: var(--c-width);
        height: var(--c-height);
        border-radius: var(--c-border);
        background: linear-gradient(to bottom right, var(--background-image));
        mix-blend-mode: var(--blend-mode);
        opacity: var(--opacity-bg, 1);
        transition: opacity var(--transition) linear;
      }

      &-image {
        // width: 100%;
        // height: auto;
        object-fit: cover;
        // border-radius: 10px;
        filter: grayscale(1);
        transition: filter var(--transition);
        clip-path: polygon(0% 0%, 100% 0%, var(--x-y1, 138% 83%), var(--x-y2, 47% 103%), var(--x-y3, 33% 90%), var(--x-y4, 0% 104%))
      }

      &-checkbox {
        background: var(--background-checkbox);
        border: 2px solid #fff;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 1;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        opacity: 0;
        transform: scale(0);
        transition: transform var(--transition), opacity var(--transition);

        &--svg {
          width: 16px;
          height: 13px;
          fill: none;
          margin: 0px 0 1px 4px;
          stroke: #fff;
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 16px;
          stroke-dashoffset: 16px;
          transition: stroke-dashoffset 0.4s ease var(--transition);
        }
      }
    }


    &-content {
      padding: 10px;
      // ::before ::after {
      //   top: 0rem;
      // }
      // ::v-deep .b-form-radio,
      // ::v-deep .custom-control {
      //   font-size: 1.1rem;
      //   line-height: 1.3;
      // }

      ::v-deep .custom-control-label {
        font-weight: 500;
        cursor: pointer;
      }
    }
  }
}
</style>
